<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">CONTENTS</h2>
<div class="contentsEntry" id="contentsEntry3">
<p class="contentsEntryName"><a href="#/tamedthebarbarianking_ch01#ch01">CHAPTER ONE</a></p></div>
<div class="contentsEntry" id="contentsEntry4">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch02#ch02" title="Link target outside of Sample">CHAPTER TWO</span></p></div>
<div class="contentsEntry" id="contentsEntry5">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch03#ch03" title="Link target outside of Sample">CHAPTER THREE</span></p></div>
<div class="contentsEntry" id="contentsEntry6">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch04#ch04" title="Link target outside of Sample">CHAPTER FOUR</span></p></div>
<div class="contentsEntry" id="contentsEntry7">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch05#ch05" title="Link target outside of Sample">CHAPTER FIVE</span></p></div>
<div class="contentsEntry" id="contentsEntry8">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch06#ch06" title="Link target outside of Sample">CHAPTER SIX</span></p></div>
<div class="contentsEntry" id="contentsEntry9">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch07#ch07" title="Link target outside of Sample">CHAPTER SEVEN</span></p></div>
<div class="contentsEntry" id="contentsEntry10">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch08#ch08" title="Link target outside of Sample">CHAPTER EIGHT</span></p></div>
<div class="contentsEntry" id="contentsEntry11">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch09#ch09" title="Link target outside of Sample">CHAPTER NINE</span></p></div>
<div class="contentsEntry" id="contentsEntry12">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch10#ch10" title="Link target outside of Sample">CHAPTER TEN</span></p></div>
<div class="contentsEntry" id="contentsEntry13">
<p class="contentsEntryName"><span href="#/tamedthebarbarianking_ch11#ch11" title="Link target outside of Sample">CHAPTER ELEVEN</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tamedthebarbarianking_con01.vue?71eb52bb